import * as _ from 'lodash';

/* "TOTAL_DEPOSITS" -> "Total deposits" for the names of variables written in camel case or upper snake case. */
export const humanize = key =>
    _.upperFirst(
        _.lowerCase(_.replace(String(key), /([a-z0-9])([A-Z])/g, '$1 $2'))
    );
